export type ThemeName = "light" | "dark" | "black" | "comfort";

export function initialTheme(): ThemeName {
  const stored = localStorage.getItem("htzap-theme");
  const version = localStorage.getItem("htzap-theme-version");
  if (version === "2" && (stored === "light" || stored === "dark" || stored === "black" || stored === "comfort")) {
    return stored;
  }
  return stored === "light" ? "light" : "black";
}
